//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";

import LocationBox from "./LocationBox";

export default {
	name: "StateContainer",
	components: {
		LocationBox
	},
	props: {
		locationArray: Array,
		stateName: String
	},
	computed: {
		...mapGetters([
			"currentView",
			"stateNames",
		]),
	}
}
